export default audioContext => (
  global.AudioContext && (audioContext instanceof global.AudioContext))
    || (global.webkitAudioContext && (audioContext instanceof global.webkitAudioContext)
    );
